import { Injectable } from '@angular/core';
import { Error } from '../../shared/interfaces/error.interfaces';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class ErrorService {

  constructor(
    private router: Router
  ) { }

  handleErrorMessage(error: Error) {
    console.log(`${error.error.code}:\n${error.error.message}`);

    switch (error.error.code) {

      case "invalid-user-id":
        return 'ERRORS.INVALID_USER';
      case "invalid-account-id":
        return 'ERRORS.INVALID_ACCOUNT'
      case "invalid-account-number":
        return 'ERRORS.INVALID_ACCOUNT_NUMBER';
      case "invalid-click-device":
        return 'ERRORS.INVALID_DEVICE';
      case "invalid-dealer":
      case "invalid-dealer-id":
      case "invalid-dealer-path":
        return 'ERRORS.INVALID_DEALER';
      case "invalid-subdealer-id":
        return 'ERRORS.INVALID_SUBDEALER';
      case "invalid-event-id":
        return 'ERRORS.INVALID_EVENT';
      case "invalid-definition-id":
        return 'ERRORS.INVALID_DEFINITION';
      case "invalid-protocol-id":
        return 'ERRORS.INVALID_PROTOCOL';
      case "invalid-webhook-id":
        return 'ERRORS.INVALID_WEBHOOK';
      case "invalid-color":
        return 'ERRORS.INVALID_COLOR';
      case "invalid-url":
      case "invalid-webhook-url":
        return 'ERRORS.INVALID_URL';
      case "image-wrong-dimensions":
        return 'ERRORS.INVALID_IMAGE';
      case "invalid-apikey":
        return 'ERRORS.INVALID_APIKEY';
      case "invalid-file-format":
      case "invalid-file-type":
        return 'ERRORS.INVALID_FILE_FORMAT'
      case "invalid-name":
        return 'ERRORS.INVALID_NAME';
      case "invalid-email":
        return 'ERRORS.INVALID_EMAIL';
      case "invalid-phone-number":
        return 'ERRORS.INVALID_PHONE';
      case "invalid-company-name":
        return 'ERRORS.INVALID_COMPANY';
      case "invalid-address":
      case "invalid-city-name":
      case "invalid-zip-code":
      case "invalid-state-name":
      case "invalid-country-name":
        return 'ERRORS.INVALID_ADRESS'
      case "invalid-parameters":
      case "bad-request":
      case "invalid-query-parameters":
      case "invalid-event-data":
      case "invalid-id":
      case "invalid-equipments":
      case "invalid-equipment":
        switch (error.error.message) {
          case "Username and password are required":
            return 'ERRORS.INVALID_USER_OR_PASSWORD';
          case "Equipment not compatible with firmware upgrade":
            return 'ERRORS.INVALID_FIRMWARE_FOR_UPGRADE';
          default:
            break
        }
        return 'ERRORS.INVALID_PARAMETERS';

      case "invalid-credentials":
      case "invalid-username-or-password":
        return 'ERRORS.INVALID_USER_OR_PASSWORD';

      case "invalid-auth-token":
        this.router.navigate([`/login`])
        return 'ERRORS.INVALID_AUTHENTICATION'

      case "authorization-error":
      case "unauthorized":
      case "not-authorized":
      case "dealer-not-authorized":
        // this.router.navigate([`/main`])
        return 'ERRORS.UNAUTHORIZED'

      case "no-dealer-for-user":
        return 'ERRORS.NO_DEALER_FOR_USER';

      case "user-not-found":
      case "no-user-found":
        return 'ERRORS.NOT_FOUND_USER';
      case "account-not-found":
        return 'ERRORS.NOT_FOUND_ACCOUNT';
      case "equipment-not-found":
        return 'ERRORS.NOT_FOUND_EQUIPMENT';
      case "event-not-found":
        return 'ERRORS.NOT_FOUND_EVENT';
      case "webhook-not-found":
        return 'ERRORS.NOT_FOUND_WEBHOOK';
      case "apikey-not-found":
        return 'ERRORS.NOT_FOUND_APIKEY';
      case "file-not-found":
        return 'ERRORS.NOT_FOUND_FILE';
      case "not-found":
        switch (error.error.message) {
          case "Equipment not found":
            return 'ERRORS.NOT_FOUND_EQUIPMENT';
          default:
            return 'ERRORS.NOT_FOUND';
        }

      case "username-already-in-use":
        return 'ERRORS.CONFLICT_USERNAME';
      case "email-already-in-use":
        return "ERRORS.CONFLICT_EMAIL";
      case "account-number-conflict":
        return 'ERRORS.CONFLICT_ACCOUNT_NUMBER'
      case "file-already-exists":
        return 'ERRORS.CONFLICT_FILE'
      case "duplicate-apikey":
        return 'ERRORS.CONFLICT_APIKEY';
      case 'equipment-assignment-conflict':
        return 'ERRORS.CONFLICT_EQUIPMENT_ASSIGNMENT';
      case 'equipment-partition-conflict':
        return 'ERRORS.CONFLICT_EQUIPMENT_PARTITION';
      case 'account-conflict':
      case 'account-number-partition-conflict':
        return 'ERRORS.CONFLICT_ACCOUNT_PARTITION';
      case 'duplicate-account-number-partition':
        return 'ERRORS.CONFLICT_ACCOUNT_MIGRATION';
      case "equipment-conflict":
        return 'ERRORS.EQUIPMENT_CONFLICT';
      case "account-multiple-equipments":
        return 'ERRORS.ACCOUNT_MULTIPLE_EQUIPMENTS';
      case "already-exists":
        switch (error.error.message) {
          case 'Remote code already registered for this organization':
            return 'ERRORS.REMOTE_ALREADY_EXISTS';
          default:
            return 'ERRORS.CONFLICT';
        }
      case "already-claimed-by-other-dealer":
        return 'ERRORS.ALREADY_CLAIMED_BY_OTHER_DEALER';
      case "already-claimed-by-you":
        return 'ERRORS.ALREADY_CLAIMED_BY_YOU';
      case "conflict":
        return 'ERRORS.CONFLICT';

      case "dealer-not-empty":
        return 'ERRORS.DEALER_NOT_EMPTY';
      case "dealer-apykeys-not-revoked":
        return 'ERRORS.DEALER_APIKEYS_NOT_REVOKED';
      case "dealer-has-children":
        return 'ERRORS.DEALER_HAS_CHILDREN';

      case "account-not-linked":
        return 'ERRORS.ACCOUNT_NOT_LINKED';

      case "equipment-disconnected":
        return 'ERRORS.EQUIPMENT_DISCONNECTED';

      case "command-timed-out":
        return 'ERRORS.COMMAND_TIMEOUT';

      case "redis-error":
        return "ERRORS.REDIS";

      case "event-creation-failed":
        return 'ERRORS.EVENT_CREATION_FAILED'

      case "no-available-ports":
        return 'ERRORS.NO_AVAILABLE_PORTS';

      case "webhook-protected":
        return 'ERRORS.PROTECTED';

      case "webhook-test-failed":
        return 'ERRORS.TEST_FAILED';

      case "internal-server-error":
      case "internal-error":
      case "unknown":
        switch (error.error.message) {
          case 'error: update or delete on table "click_commands" violates foreign key constraint "click_template_commands_click_command_id_fkey" on table "click_template_commands"':
            return 'ERRORS.COMMAND_IN_TEMPLATE';
          case 'command-timed-out':
            return 'ERRORS.COMMAND_TIMEOUT';
          case 'Internal error':
          case 'Internal Server Error':
            return 'ERRORS.UNKNOWN_SERVER_ERROR';
          case 'Error: User not found or dealer not valid':
            return 'ERRORS.USER_NOT_VERIFIED';
          case 'error: update or delete on table "event_definitions" violates foreign key constraint "events_event_definitions_id_fkey" on table "events"':
            return 'ERRORS.EVENT_DEFINITION_IN_USE';
          case 'invalid input syntax for type integer: "FFF"':
          case 'invalid input syntax for type integer: "FF1"':
            return 'ERRORS.INVALID_INTEGER_SYNTAX';
          case 'error: null value in column "dealer_id" of relation "accounts" violates not-null constraint':
          case 'null value in column "dealer_id" of relation "accounts" violates not-null constraint':
            return 'ERRORS.DEALER_ID_NULL_CONSTRAINT';
          default:
            return 'ERRORS.UNKNOWN_SERVER_ERROR';
        }

      default:
        return 'ERRORS.UNKNOWN_ERROR';
    }
  }

}
